<template>
  <div
    :class="{
      'container mx-auto p-0': true,
    }"
  >
    <PortableText
      v-if="heading?.flipCardPortableText"
      :class="{
        'content-card-heading g-0 mx-auto mb-18px text-center text-www-color-neutral-medium-dark lg:max-w-13/20': true,
      }"
      :portable-data="heading?.flipCardPortableText"
    />
    <div
      :class="{
        'flex flex-col justify-center md:flex-row md:flex-wrap': true,
      }"
    >
      <div
        v-for="(card, index) in cards"
        :key="index"
        :class="{
          'mt-5 w-full md:w-1/2 md:px-3 lg:mt-30px lg:w-1/3 lg:px-3': true,
        }"
      >
        <ContentManualCard
          v-bind="card"
          :use-dark-theme="useDarkTheme"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import PortableText from '~/components/Atoms/PortableText/PortableText.vue';
import ContentManualCard from '~/components/Atoms/ManualCard/ContentManualCard.vue';
import type { ContentCard } from '~/sanity/types';

interface Props extends ContentCard {
  useDarkTheme?: boolean;
}

defineProps<Props>();
</script>

<style>
.content-card-heading p {
  margin-bottom: 15px !important;
  line-height: 21px !important;
}

@media (max-width: 768px) {
  .content-card-heading p {
    font-size: 12px !important;
    line-height: 14px !important;
  }
}
</style>
